// config
import * as http from 'utils/http';
import config from 'config';
// utils

const getUnreadAlerts = async () => {
  const data = await http.get(`${config.API_URL}price-negotiation/alerts/?page_size=1&unread=true`);
  return data;
};

export default getUnreadAlerts;
